import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c33e7ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-content-center flex-column mt-2 mb-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-black text-weight-600 text-center" }, "\n        お仕事の確定おめでとうございます！\n      ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-center" }, "check!", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1 text-black text-weight-600 text-center" }, "\n        カレンダーに予定を登録してください\n      ", -1))
const _hoisted_6 = { class: "mx-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-size-14 mb-3" }, "\n        お手持ちのカレンダーなどにお仕事の予定を登録してください。\n      ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-size-12 mb-3" }, [
  /*#__PURE__*/_createTextVNode("\n        キャンセルの場合は、下記の手順が必要です。無断欠勤の場合は一時的にアカウントが利用停止となりますのでご注意ください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        ①すぐに事業所様に直接「電話」にて連絡"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        ②システム上で仕事をキャンセル\n      ")
], -1))

import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterCalendar',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const productAssetSuffix = computed(() => authStore.productAssetSuffix);
const mascotImage = computed(() =>
  require("@/assets/svg/caikuma_send_message" +
    authStore.productAssetSuffix +
    ".svg")
);
const orderReserveCompletedRoute = computed(() => ({
  name: "OrdersReserveCompleted",
  params: { applicationId: route.params.applicationId }
}));

function onClickBack() {
  router.back();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n    カレンダー登録\n  ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          width: "114",
          src: mascotImage.value
        }, null, 8, _hoisted_2),
        _createTextVNode(),
        _hoisted_3
      ]),
      _createTextVNode(),
      _createElementVNode("div", {
        class: _normalizeClass(["mt-4 mb-3 pt-2 px-3 pb-3", `bg-banner${productAssetSuffix.value}`])
      }, [
        _hoisted_4,
        _createTextVNode(),
        _hoisted_5
      ], 2),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createTextVNode(),
        _hoisted_8,
        _createTextVNode(),
        _createVNode(AppButton, {
          class: "w-100 mt-2",
          to: orderReserveCompletedRoute.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("完了")
          ], undefined, true),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ], 64))
}
}

})